"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RadioButton = _ref => {
  let {
    active,
    text,
    className,
    color
  } = _ref;

  const renderCircle = (r, className, mask, fill) => /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      transition: "r 300ms"
    },
    cx: "67",
    cy: "67",
    r: r,
    fill: fill,
    className: className,
    mask: mask
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      cursor: 'default'
    },
    className: "radioButton ".concat(active ? ' active' : '')
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "".concat(className || ''),
    viewBox: "0 0 132.29 132.29",
    height: "35",
    width: "35"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    width: "200",
    height: "200",
    fill: "white"
  }), renderCircle(55, 'black', undefined, '#000')), renderCircle(65, 'mainShape', 'url(#mask)', color), renderCircle(active ? 40 : 0, 'mainShape', undefined, color)), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginLeft: '10px',
      color
    }
  }, text));
};

exports.RadioButton = RadioButton;